'use strict';
const RequestManager = require('../helpers/request-manager');
const ParamsManager = require('../helpers/params-manager');
const errorHandler = require('../helpers/error-handler');

class Utilities {
  constructor(credentials, request, sdkConfiguration) {
    this.requestManager = new RequestManager(sdkConfiguration, request, credentials);
    this.paramsManager = new ParamsManager();
  }

  deleteCustomer(customerId) {
    this.requestManager.requestConfigurationManager.setApi('DeleteCustomer');
    this.paramsManager.addPathParam(customerId);
    return this.requestManager.makeRequest(this.paramsManager.getRequestParams())
      .catch(errorHandler.removeMicrosoftDetails);
  }

  getDomainAvailability(domain) {
    this.requestManager.requestConfigurationManager.setApi('GetDomainAvailability');
    this.paramsManager.addPathParam(domain);
    return this.requestManager.makeRequest(this.paramsManager.getRequestParams())
      .catch(errorHandler.removeMicrosoftDetails);
  }

  getAddressRules(country) {
    this.requestManager.requestConfigurationManager.setApi('GetAddresRules');
    this.paramsManager.addPathParam(country);
    return this.requestManager.makeRequest(this.paramsManager.getRequestParams())
      .catch(errorHandler.removeMicrosoftDetails);
  }

  getPartnerActivityRecords(startDate, endDate) {
    startDate = startDate || {};
    endDate = endDate || {};
    this.requestManager.requestConfigurationManager.setApi('GetPartnerActivityRecords');
    this.paramsManager.addQueryParam({ startDate }, { endDate });
    return this.requestManager.makeRequest(this.paramsManager.getRequestParams())
      .catch(errorHandler.removeMicrosoftDetails);
  }
}

module.exports = Utilities;
